import {defineStore} from 'pinia'

// @ts-ignore
export const useMembershipStore = defineStore('membership', {
  state: () => ({
    pathPrefix: '/membership'
  }),
  getters: {},
  actions: {
    /**
     * 이달의 미팅 신청
     * @param payload
     * @returns {Promise<void>}
     */
    async postMembershipMonthlyApplication(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/meeting`
      return await $apiClient(path, {
        method: 'POST',
        body: {
          membershipMonthlyInfoId: payload.membershipMonthlyInfoId,
          companyName: payload.companyName,
          participant: payload.participant
        }
      })
    },
    /**
     * 이달의 미팅 조회
     * @param payload
     * @returns {Promise<void>}
     */
    async getMembershipMontlyInfo(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/meeting`
      const query = `?type=${payload.type}&yearMonth=${payload.yearMonth ? payload.yearMonth : ''}`
      return await $apiClient(`${path}${query}`, {
        method: 'GET'
      })
    },

    /**
     * 회원가입안내 - 회원가입 신청폼 조회
     * @param type
     * @returns {Promise<void>}
     */
    async getMembershipJoinForm(type) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/information/join-form`
      const query = `?type=${type}`
      return await $apiClient(`${path}${query}`, {
        method: 'GET'
      })
    },
    /**
     * 회원가입안내 - 인사말 조회
     * @param type
     * @returns {Promise<void>}
     */
    async getMembershipGreeting(type) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/information/greeting`
      const query = `?type=${type}`
      return await $apiClient(`${path}${query}`, {
        method: 'GET'
      })
    },
    /**
     * 회원가입안내 - 운영방법 및 회원혜택 조회
     * @param type
     * @returns {Promise<void>}
     */
    async getMembershipOperation(type) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/information/opertaion`
      const query = `?type=${type}`
      return await $apiClient(`${path}${query}`, {
        method: 'GET'
      })
    },
    /**
     * 회원가입안내 - 코디네이터 조회
     * @returns {Promise<void>}
     */
    async getMembershipCoordinator() {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/information/coordinator`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    /**
     * 회원가입안내 - 회원사 리스트 조회
     * @param payload
     * @returns {Promise<void>}
     */
    async getMembershipCompanyList(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/information/company/${payload.type}`
      let query = `?companyType=${payload.companyType}&page=${payload.page}&limit=${payload.limit}`
      if (payload.keyword) {
        query += `&keyword=${payload.keyword}`
      }
      if (payload.consonant) {
        query += `&consonant=${payload.consonant}`
      }
      return await $apiClient(`${path}${query}`, {
        method: 'GET'
      })
    },
    /**
     * 정보자료 게시글 리스트 조회
     * @param payload
     * @returns {Promise<void>}
     */
    async getMembershipDataBoardList(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/board/data`
      const query = `?type=${payload.type}&dataType=${payload.dataType}&page=${payload.page}&limit=${payload.limit}`
      return await $apiClient(`${path}${query}`, {
        method: 'GET'
      })
    },
    /**
     * 정보자료 게시글 상세 조회
     * @param id
     * @returns {Promise<void>}
     */
    async getMembershipDataBoardDetail(id) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/board/data/${id}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    /**
     * 포토존 게시글 리스트 조회
     * @param payload
     * @returns {Promise<void>}
     */
    async getMembershipPhotoBoardList(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/board/photo`
      const query = `?type=${payload.type}&page=${payload.page}&limit=${payload.limit}`
      return await $apiClient(`${path}${query}`, {
        method: 'GET'
      })
    },
    /**
     * 포토존 게시글 상세 조회
     * @param id
     * @returns {Promise<void>}
     */
    async getMembershipPhotoBoardDetail(id) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/board/photo/${id}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    /**
     * 회원사업 구독여부 조회
     * @param type
     * @returns {Promise<void>}
     */
    async getMembershipSubscribe(type) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/subscribe/${type}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    /**
     * 회원사업 구독 히스토리 조회
     * @param type
     * @returns {Promise<void>}
     */
    async getMembershipSubscribeHistory(type) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/subscribe/history/${type}`
      return await $apiClient(path, {
        method: 'GET'
      })
    }
  }
})
